"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("D:\\\u9879\u76EE\u7BA1\u7406\\\u65E7\u6362\u65B0\\\u6E90\u7801\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\@babel\\runtime\\regenerator\\index.js"));

var _sms = require("@/api/sms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  name: 'Register',
  data: function data() {
    var validatePhone = function validatePhone(rule, value, callback) {
      if (!value) {
        return callback(new Error('请填写手机号'));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error('手机号格式不正确!'));
      } else {
        callback();
      }
    };

    return {
      loading: false,
      passwordType: 'password',
      captchatImg: '',
      cutNUm: '获取验证码',
      canClick: true,
      formInline: {
        account: '',
        code: '',
        domain: '',
        phone: '',
        password: ''
      },
      ruleInline: {
        password: [{
          required: true,
          message: '请输入短信平台密码/token',
          trigger: 'blur'
        }],
        domain: [{
          required: true,
          message: '请输入网址域名',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          validator: validatePhone,
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    showPwd: function showPwd() {
      var _this = this;

      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }

      this.$nextTick(function () {
        _this.$refs.password.focus();
      });
    },
    // 短信验证码
    cutDown: function cutDown() {
      var _this2 = this;

      if (this.formInline.phone) {
        if (!this.canClick) return;
        this.canClick = false;
        this.cutNUm = 60;
        (0, _sms.captchaApi)({
          phone: this.formInline.phone,
          types: 0
        }).then( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee(res) {
            return _index.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _this2.$message.success('发送成功');

                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
        var time = setInterval(function () {
          _this2.cutNUm--;

          if (_this2.cutNUm === 0) {
            _this2.cutNUm = '获取验证码';
            _this2.canClick = true;
            clearInterval(time);
          }
        }, 1000);
      } else {
        this.$message.warning('请填写手机号!');
      }
    },
    // 注册
    handleSubmit: function handleSubmit(name) {
      var _this3 = this;

      this.formInline.account = this.formInline.phone;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this3.loading = true;
          (0, _sms.registerApi)(_this3.formInline).then( /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee2(res) {
              return _index.default.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _this3.$message.success('注册成功');

                      setTimeout(function () {
                        _this3.changelogo();
                      }, 1000);
                      _this3.loading = false;

                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            }));

            return function (_x2) {
              return _ref2.apply(this, arguments);
            };
          }()).catch(function () {
            _this3.loading = false;
          });
        } else {
          return false;
        }
      });
    },
    // 立即登录
    changelogo: function changelogo() {
      this.$emit('on-change');
    }
  }
};
exports.default = _default;